import {AfterContentInit, AfterViewInit, Component} from '@angular/core';
import {
    ControlService,
    IconService,
    SubtitlesService,
    TimeDateService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'two-switch',
    templateUrl: './two-switch.component.html',
    styleUrls: ['./two-switch.component.scss']
})
export class TwoSwitchComponent implements AfterViewInit, AfterContentInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
        public timeDate: TimeDateService,
    ) {
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    ngAfterContentInit() {
        this.timeDate.setTimeValue()
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
